import { GameStoreOneOptionsType } from '@op/pages/Overview/CompareKeyMetrics/constants';
import React, { useState } from 'react';
import { Segment } from 'tea-component';
import UserScoreCommon from './component/UserScoreCommon';
import ChannelLabel from '@op/components/ChannelLabel';
import './index.scss';
import ScoreTrendBox from './component/ScoreTrendBox';
import { useIntl } from 'umi';
import classNames from 'classnames';

export default function MobileGameStore(props: any) {
  const { filter, data, trendsData, className} = props || {};
  const [store, setStore] = useState<GameStoreOneOptionsType>('app store');
  const { formatMessage } = useIntl();

  const storeOptions: { value: GameStoreOneOptionsType; label: string; iconClass: string; }[] = [
    {
      value: 'app store',
      label: 'App Store',
      iconClass: 'dbh-studio-game-store-mobile-segment-icon-app-store',
    },
    {
      value: 'google play',
      label: 'Google Play',
      iconClass: 'dbh-studio-game-store-mobile-segment-icon',
    },
  ];

  const scoreTypes = [
    { type: 'lifetime', label: 'Lifetime' },
    { type: 'selected', label: 'Selected' },
  ] as const;

  return (
    <div className={classNames(className,"dbh-studio-game-store-mobile")}>
      <Segment
        value={store}
        onChange={(value: GameStoreOneOptionsType) => setStore(value)}
        options={storeOptions.map((option) => ({
          value: option.value,
          text: (
            <div className="dbh-studio-game-store-mobile-segment">
              <ChannelLabel
                className={option.iconClass}
                channel_name={option.value}
                showText={false}
              />
              <span>{option.label}</span>
            </div>
          ),
        }))}
      />

      <div style={{ display: "flex" }}>
        <div className="dbh-studio-game-store-mobile-left">
          {scoreTypes.map(({ type }) => (
            <UserScoreCommon
              key={type}
              type={type}
              filter={filter}
              platform={store}
              data={data?.[store]?.[type]}
            />
          ))}
        </div>
        <div className="dbh-studio-game-store-mobile-right">
          <div className="dbh-studio-game-store-mobile-trend-title">
            {formatMessage({ id: 'Score Trends' })}
          </div>
          <ScoreTrendBox
            filterParams={filter}
            platformData={trendsData[store]}
            platform={store}
            key={store}
            height={185}
          />
        </div>
      </div>
    </div>
  );
}
